import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Errors, LeaderboardService, LocalService } from '../../../../core';

@Component({
  selector: 'app-challenge-lcd',
  templateUrl: './challenge-lcd.component.html',
  styleUrls: ['./challenge-lcd.component.scss'],
})
export class ChallengeLcdComponent implements OnChanges, AfterViewInit {
  @Input() activityLeaderboardData: any;
  @Input() optOut: any;
  @Input() userProfile: any;
  @Input() begeoid: any;
  @Input() size: number = 5;

  isLoading: boolean = false;
  leaderboardChallengeData: any;
  selectedChallenge: any = null;
  leaderboardRankDetails: any;
  page: number[] = [];
  mainCategoryColumns: any[] = [];
  subcategoryColumns: any[] = [];
  errors: Errors = { errors: {} };

  @ViewChild('groupNameCellTemplate') groupNameCellTemplate!: TemplateRef<any>;
  @ViewChild('partnerNameCellTemplate') partnerNameCellTemplate!: TemplateRef<any>;
  @ViewChild('progressCellTemplate') progressCellTemplate!: TemplateRef<any>;
  @ViewChild('eligibilityCellTemplate') eligibilityCellTemplate!: TemplateRef<any>;
  @ViewChild('expandedSubcategoryTemplate') expandedSubcategoryTemplate!: TemplateRef<any>;

  constructor(
    private leaderboardService: LeaderboardService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.userProfile = LocalService.get('userProfile');
    if (this.optOut === false || this.optOut === true) {
      if (this.activityLeaderboardData && this.activityLeaderboardData.leaderTab == 'LCD') {
        this.leaderboardChallengeData = this.activityLeaderboardData.data;
        this.selectedChallenge = this.leaderboardChallengeData[0] || null;
        this.mainCategoryColumns = [
          { field: 'rank', header: 'Rank', align: 'center' },
          { field: 'groupName', header: 'Band - Country Group', align: 'center' },
          { field: 'partnerName', header: 'Partner Name', align: 'center' },
          { field: 'progressPercentage', header: 'Progress', align: 'center' },
          { field: 'completed', header: 'Eligibility', align: 'center' },
        ];
        this.subcategoryColumns = [
          { field: 'targetName', header: 'Target Name' },
          { field: 'targetBooking', header: 'Target Booking', prefix: '$' },
          { field: 'achievedBooking', header: 'Achieved Booking', prefix: '$' },
          { field: 'percentage', header: 'Progress %', align: 'center' },
        ];
        this.leaderBoardChallengeList();
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.mainCategoryColumns.length >= 5) {
      this.mainCategoryColumns[1].cellTemplate = this.groupNameCellTemplate;
      this.mainCategoryColumns[2].cellTemplate = this.partnerNameCellTemplate;
      this.mainCategoryColumns[3].cellTemplate = this.progressCellTemplate;
      this.mainCategoryColumns[4].cellTemplate = this.eligibilityCellTemplate;
    }
    this.cdr.detectChanges();
  }

  get selectedChallengeIndex(): number {
    if (!this.leaderboardChallengeData || !this.selectedChallenge) {
      return 0;
    }
    return this.leaderboardChallengeData.indexOf(this.selectedChallenge);
  }

  isRowExpanded = (row: any): boolean => !!row.panelStatus;
  rowClass = (row: any): string =>
    this.begeoid === row.partnerBeGeoId ? 'dt-row--selected' : '';

  progressBarClass(pct: number): string {
    return pct >= 100 ? 'bg-green-500' : 'bg-lightblue';
  }

  progressTextClass(pct: number): string {
    return pct >= 100 ? 'text-green-600' : 'text-cisco';
  }

  eligibilityClass(completed: boolean): string {
    return completed ? 'bg-green-100 text-green-700' : 'bg-gray-300 text-gray-600';
  }

  eligibilityLabel(completed: boolean): string {
    return completed ? 'Achieved' : 'Pending';
  }

  expandIcon(panelStatus: boolean): string {
    return panelStatus ? 'expand_less' : 'expand_more';
  }

  commaNumberFormate(x: any): string {
    if (x === 0 || x === null) {
      return '0';
    }
    if (x) {
      return parseFloat(x.toString())
        .toFixed(0)
        .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    }
    return x;
  }

  leaderBoardChallengeList(): void {
    this.leaderboardChallengeData.forEach((element: any, i: number) => {
      element.mainCategory = [];
      element.subcategory = [];
      if (i == 0) {
        element.accordianState = true;
        this.getLeadeboardChgDetailList(i, element.id);
        this.getSpecificLeaderboardData(element.loggedUserLeaderboardChallenegeId);
      } else {
        element.accordianState = false;
      }
    });
  }

  openPanelList(i: number, id: any): void {
    this.leaderboardChallengeData[i].subcategory = [];
    this.leaderboardChallengeData.forEach((element: any, index: number) => {
      if (i === index) {
        element.accordianState = true;
        this.getSpecificLeaderboardData(id);
      } else {
        element.accordianState = false;
      }
    });
  }

  getLeadeboardChgDetailList(i: number, id: any, event?: any): void {
    this.page[i] = event ? event : 1;
    const compId =
      this.userProfile && this.userProfile.company ? this.userProfile.company.id : null;
    const req =
      id +
      '?companyId=' +
      compId +
      '&page=' +
      (this.page[i] - 1) +
      '&size=' +
      this.size;

    this.isLoading = true;
    this.leaderboardService.getLeaderboardChallengeData(req).subscribe((res) => {
      this.isLoading = false;
      if (event) {
        this.leaderboardChallengeData[i].mainCategory.content = [];
        this.leaderboardChallengeData[i].mainCategory.content = res.content;
      } else {
        this.leaderboardChallengeData[i].mainCategory = res;
      }
    });
  }

  getLeaderboardChgSubcategoryData(id: any, index: number, chalgId: any): void {
    this.leaderboardService.getLeaderboardChgSubcategoryData(id).subscribe(
      (res) => {
        this.leaderboardChallengeData.forEach((element: any) => {
          if (element.id == chalgId) {
            element.subcategory = res;
            element.mainCategory.content[index].panelStatus = true;
          }
        });
      },
      (err) => {
        this.errors = err;
      }
    );
  }

  onChallengeSelect(challenge: any): void {
    this.selectedChallenge = challenge;
    const index = this.leaderboardChallengeData.findIndex(
      (c: any) => c.id === challenge.id
    );
    this.getSpecificLeaderboardData(challenge.loggedUserLeaderboardChallenegeId);
    this.getLeadeboardChgDetailList(index >= 0 ? index : 0, challenge.id);
  }

  toggleSubcategory(row: any, challengeId: any): void {
    const challenge = this.leaderboardChallengeData.find(
      (c: any) => c.id === challengeId
    );
    if (!challenge) {
      return;
    }
    const j = challenge.mainCategory.content.indexOf(row);
    if (row.panelStatus) {
      const i = this.leaderboardChallengeData.indexOf(challenge);
      this.closeLeaderboardchgSubcategory(i, challengeId, j);
    } else {
      this.getLeaderboardChgSubcategoryData(row.userLeaderboardChallengeId, j, challengeId);
    }
  }

  closeLeaderboardchgSubcategory(i: number, id: any, j: number): void {
    this.leaderboardChallengeData.forEach((element: any) => {
      if (element.id == id) {
        element.mainCategory.content[j].panelStatus = false;
      }
    });
    this.leaderboardChallengeData[i].subcategory = [];
  }

  closePanelAccordian(i: number): void {
    this.leaderboardChallengeData.forEach((ele: any, ind: number) => {
      if (i === ind) {
        ele.accordianState = false;
      }
    });
    this.leaderboardChallengeData[i].subcategory = [];
  }

  getSpecificLeaderboardData(id: any): void {
    this.leaderboardService.getLeaderboardRankDetails(id).subscribe(
      (response) => {
        this.leaderboardRankDetails = response;
      },
      (err) => {
        this.errors = err;
      }
    );
  }
}
